/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Ordered from least to most access top -> bottom
 */
export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessLevel = {
  view: 'view',
  comment: 'comment',
  edit: 'edit',
  owner: 'owner',
} as const;
